import React, { Component } from 'react';
import PropTypes from 'prop-types';

import MoreVideosModule from './MoreVideosModule';
import { Ad, Image, SocialIcon, generateCuts, parseCutsObj } from '@yes/components';

class SelectionContent extends Component {
    constructor(props) {
        super(props);
    }

    renderImage(image, className) {
        if (!image) {
            return null;
        }
        const { templateUrl, title } = image;
        const imgCuts = generateCuts(templateUrl, 'jpg', '1:1', 'face');

        return (
            <div className={className}>
                <Image srcSet={parseCutsObj(imgCuts)} alt={title} title={title} lazyload />
            </div>
        );
    }

    renderMigratedHtml(content, className) {
        const innerHtml = { __html: content };
        return <div className={className} dangerouslySetInnerHTML={innerHtml} />;
    }

    renderSocial(socials) {
        return socials.map((social) => {
            const { linkText, isPopup, linkUrl } = social;
            const socialName = linkText.toLowerCase();
            return (
                <SocialIcon
                    key={`social-icon-${socialName}`}
                    className="social--icons--icon"
                    socialName={socialName === 'email' ? 'envelope-o' : socialName}
                    newWindow={isPopup}
                    url={linkUrl}
                />
            );
        });
    }

    render() {
        const { adContentId, selectionData } = this.props;
        const { image, migratedHtml, relatedVideos, socials, subhead, title } = selectionData;

        return (
            <div className="selection-content-container">
                <div className="body-wrapper">
                    <h2 className="content-header">{title}</h2>
                    {subhead && <div className="content-subheader">{subhead}</div>}
                    <div className="selection-content__body-wrapper">
                        <div className="column-left">
                            <div className="left-content-wrapper">
                                {this.renderImage(image, 'selection-content__image')}
                                <div className="selection-content__sub">
                                    <div className="selection-content__share social--icons">
                                        {this.renderSocial(socials)}
                                    </div>
                                </div>
                                <div className="selection-content__body">{this.renderMigratedHtml(migratedHtml)}</div>
                                <Ad
                                    className={'p-ad ad-responsive-slot news-bottom-banner-mobile'}
                                    sectionName={adContentId}
                                    sizeMapping={[
                                        { viewport: [0, 0], slot: [300, 250] },
                                        { viewport: [768, 0], slot: [728, 90] }
                                    ]}
                                    targeting={{ pos: 1 }}
                                />
                            </div>
                        </div>

                        <div className="column-right">
                            <Ad
                                className={'p-ad ad-responsive-slot news-right-rail-top'}
                                sectionName={adContentId}
                                sizeMapping={[
                                    { viewport: [0, 0], slot: [0, 0] },
                                    { viewport: [1024, 0], slot: [300, 250] }
                                ]}
                                targeting={{ pos: 1 }}
                            />
                            <MoreVideosModule {...relatedVideos} />
                            <Ad
                                className={'p-ad ad-responsive-slot news-right-rail-bottom'}
                                sectionName={adContentId}
                                sizeMapping={[
                                    { viewport: [0, 0], slot: [300, 250] },
                                    { viewport: [768, 0], slot: [728, 90] },
                                    { viewport: [1024, 0], slot: [300, 250] }
                                ]}
                                targeting={{ pos: 2 }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

SelectionContent.propTypes = {
    adContentId: PropTypes.string,
    selectionData: PropTypes.shape({
        image: PropTypes.object,
        migratedHtml: PropTypes.string,
        relatedVideos: PropTypes.object,
        slug: PropTypes.string,
        socials: PropTypes.array,
        subhead: PropTypes.string,
        title: PropTypes.string
    })
};

SelectionContent.defaultProps = {
    selectionData: {}
};

export default SelectionContent;
